// custom code start
(function () {
  if (window.Tracking && window.Tracking.init && window.Tracking.init.cart) return;
  var Tracking = window.Tracking || (window.Tracking = {});
  Tracking.init = Tracking.init || {};
  Tracking.init.cart = true;

  // Variant-keyed enrichment map the Web Pixel reads so begin_checkout /
  // add_payment_info / purchase carry the same list + breadcrumb category as
  // the storefront events. Kept continuously up to date rather than written at
  // checkout-click time, so it is already in place whichever checkout button
  // the shopper uses (cart page, drawer, or notification).
  var CHECKOUT_SNAPSHOT_KEY = 'tracking:lastCartSnapshot';

  var snapshot = new Map();
  var baselinePromise = null;

  function push(payload) {
    if (typeof Tracking.push === 'function') {
      Tracking.push(payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }
  }

  function attributionFor(url) {
    if (typeof Tracking.handleFromUrl !== 'function') return null;
    if (typeof Tracking.getAttribution !== 'function') return null;
    return Tracking.getAttribution(Tracking.handleFromUrl(url));
  }

  function writeCheckoutSnapshot(cart) {
    var map = {};
    var lines = (cart && cart.items) || [];
    if (Array.isArray(lines)) {
      lines.forEach(function (line) {
        var variantId = String(line.variant_id || line.id || '');
        if (!variantId) return;
        var entry = attributionFor(line.url);
        if (!entry) return;

        var enrichment = {};
        if (entry.item_list_id) {
          enrichment.item_list_id = entry.item_list_id;
          enrichment.item_list_name = entry.item_list_name || '';
        }
        if (entry.item_category) {
          enrichment.item_category = entry.item_category;
          if (entry.item_category2) enrichment.item_category2 = entry.item_category2;
          if (entry.item_category3) enrichment.item_category3 = entry.item_category3;
        }
        if (Object.keys(enrichment).length > 0) map[variantId] = enrichment;
      });
    }

    try {
      sessionStorage.setItem(CHECKOUT_SNAPSHOT_KEY, JSON.stringify({
        t: Date.now(),
        // ERP id — the pixel cannot read metafields, so it is bridged here.
        user_id: Tracking.userId || '',
        shopify_customer_id: Tracking.shopifyCustomerId || '',
        items: map,
      }));
    } catch (e) { }
  }

  function refreshCheckoutSnapshot() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(writeCheckoutSnapshot)
      .catch(function () { });
  }

  function findVariantInIslands(variantId) {
    var key = String(variantId);
    var nodes = document.querySelectorAll('script[id^="dl-product-items-"]');
    for (var i = 0; i < nodes.length; i++) {
      try {
        var map = JSON.parse(nodes[i].textContent);
        if (map && map[key]) return map[key];
      } catch (e) { }
    }
    return null;
  }

  function isDrawerOpen() {
    var drawer = document.querySelector('cart-drawer');
    return !!(drawer && drawer.classList.contains('active'));
  }

  function resolveCartSource(source, context) {
    context = context || {};
    if (source === 'product-form') {
      if (context.inQuickAddModal) return 'plp_card';
      if (context.inProductInfo) return 'pdp';
      return 'plp_card';
    }
    if (source === 'cart-items' || source === 'cart-drawer-items') {
      return context.inDrawer ? 'popup_drawer' : 'cart_page';
    }
    return source || '';
  }

  var freeLineRules = null;

  function getFreeLineRules() {
    if (freeLineRules) return freeLineRules;
    freeLineRules = {};
    var node = document.getElementById('dl-free-line-rules');
    if (node) {
      try {
        freeLineRules = JSON.parse(node.textContent) || {};
      } catch (e) { }
    }
    return freeLineRules;
  }

  // Keep in step with snippets/datalayer-view-cart.liquid. A line is free when
  // discounts take it to 0, or when the cart draws it at 0 TL with the real
  // discount applied elsewhere (auto gift, birthday gift).
  function isFreeLine(line) {
    if (!line) return false;
    if (line.final_price === 0) return true;

    var rules = getFreeLineRules();
    var productId = String(line.product_id);
    if (line.properties && line.properties._otomatik_hediye && rules.auto_gift_zero_ids
      && rules.auto_gift_zero_ids.indexOf(',' + productId + ',') !== -1) {
      return true;
    }
    return rules.birthday_gift_product_id != null && String(rules.birthday_gift_product_id) === productId;
  }

  function applyFreeLinePrice(item, line) {
    if (item && isFreeLine(line)) {
      item.price = 0;
      item.discount = item.original_price || 0;
    }
    return item;
  }

  // total_price can still include a free line when its 0 TL is display-only, so
  // cap it at the paid lines. Subtracting the free line instead would count the
  // birthday gift twice: its order-level code is already in total_price.
  function trackedCartValue(cart) {
    var value = cart.total_price || 0;
    var paidLinesTotal = 0;
    var hasFreeLine = false;
    cart.items.forEach(function (line) {
      if (isFreeLine(line)) {
        hasFreeLine = true;
      } else {
        paidLinesTotal += line.final_line_price || 0;
      }
    });
    return (hasFreeLine ? Math.min(value, paidLinesTotal) : value) / 100;
  }

  function buildItemFromCartLine(line, quantity) {
    if (!line) return null;

    var unitPrice = (line.final_price != null ? line.final_price : (line.price || 0)) / 100;
    var originalUnitPrice = (line.original_price || line.price || 0) / 100;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'TRY';

    var item = {
      item_id: line.sku || line.handle || '',
      item_name: line.product_title || line.title || '',
      item_brand: "L'OCCITANE en Provence",
      item_variant: line.variant_title || '',
      price: unitPrice,
      original_price: originalUnitPrice,
      currency: currency,
      discount: Math.max(0, originalUnitPrice - unitPrice),
      quantity: quantity != null ? quantity : (line.quantity || 1),
      index: 0,
      affiliation: (window.Shopify && Shopify.shop) || location.hostname,
      sku: line.sku || '',
      item_variant_id: String(line.variant_id || line.id || ''),
      product_id: String(line.product_id || ''),
      image: line.image || '',
      url: line.url || '',
      description: line.product_title || line.title || '',
    };

    if (Array.isArray(line.options_with_values)) {
      line.options_with_values.forEach(function (option) {
        var key = (option.name || '').toLowerCase().trim();
        if (key) item[key] = option.value;
      });
    }

    // List and breadcrumb category are filled in by Tracking.applyAttribution
    // when the event is pushed, from the session-wide first-seen store.
    return item;
  }

  function resolveItem(variantId, cartLine, quantity) {
    var fromIsland = findVariantInIslands(variantId);
    if (fromIsland) {
      var clone = JSON.parse(JSON.stringify(fromIsland));
      clone.quantity = quantity;
      return applyFreeLinePrice(clone, cartLine);
    }
    return applyFreeLinePrice(buildItemFromCartLine(cartLine, quantity), cartLine);
  }

  function snapshotFromCart(items) {
    var map = new Map();
    if (!Array.isArray(items)) return map;
    items.forEach(function (line) {
      // An auto gift and a paid line of the same variant are separate cart lines.
      var key = String(line.variant_id || line.id);
      if (line.properties && line.properties._otomatik_hediye) key += ':auto-gift';
      var entry = map.get(key) || { quantity: 0, line: line };
      entry.quantity += line.quantity || 0;
      entry.line = line;
      map.set(key, entry);
    });
    return map;
  }

  function ensureBaseline() {
    if (baselinePromise) return baselinePromise;
    baselinePromise = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && Array.isArray(cart.items)) {
          snapshot = snapshotFromCart(cart.items);
        }
      })
      .catch(function () { });
    return baselinePromise;
  }

  function emitAddToCart(item, source, context) {
    var event = {
      event: 'add_to_cart',
      ecommerce: {
        currency: item.currency,
        value: (item.price || 0) * (item.quantity || 1),
        cart_source: resolveCartSource(source, context),
        items: [item],
      },
    };
    push(event);
  }

  function emitRemoveFromCart(item) {
    var event = {
      event: 'remove_from_cart',
      ecommerce: {
        currency: item.currency,
        value: (item.price || 0) * (item.quantity || 1),
        items: [item],
      },
    };
    push(event);
  }

  function handleProductFormAdd(payload) {
    var addedLine = payload && payload.cartData;
    if (!addedLine) return;

    var variantId = addedLine.variant_id || addedLine.id;
    var quantity = addedLine.quantity || 1;

    var fromIsland = findVariantInIslands(variantId);
    if (!fromIsland) return;

    var item = applyFreeLinePrice(JSON.parse(JSON.stringify(fromIsland)), addedLine);
    item.quantity = quantity;
    item.index = 0;

    if (payload.listId) {
      item.item_list_id = payload.listId;
      item.item_list_name = payload.listName || '';
    }

    emitAddToCart(item, 'product-form', {
      inProductInfo: !!payload.inProductInfo,
      inQuickAddModal: !!payload.inQuickAddModal,
    });
  }

  function handleCartQuantityChange(payload) {
    var cart = payload && payload.cartData;
    if (!cart || !Array.isArray(cart.items)) return;

    ensureBaseline().then(function () {
      var previous = snapshot;
      var current = snapshotFromCart(cart.items);
      var context = { inDrawer: isDrawerOpen() };

      var allKeys = {};
      previous.forEach(function (_, k) { allKeys[k] = true; });
      current.forEach(function (_, k) { allKeys[k] = true; });

      Object.keys(allKeys).forEach(function (key) {
        var prevEntry = previous.get(key);
        var currEntry = current.get(key);
        var delta = (currEntry ? currEntry.quantity : 0) - (prevEntry ? prevEntry.quantity : 0);
        if (delta === 0) return;

        var line = currEntry ? currEntry.line : prevEntry.line;
        var item = resolveItem(line.variant_id || line.id, line, Math.abs(delta));
        if (!item) return;

        if (delta > 0) {
          emitAddToCart(item, 'cart-items', context);
        } else {
          emitRemoveFromCart(item);
        }
      });

      snapshot = current;
    });
  }

  function emitDrawerViewCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;

        var items = cart.items.map(function (line, index) {
          var item = resolveItem(line.variant_id || line.id, line, line.quantity);
          if (item) item.index = index;
          return item;
        }).filter(Boolean);

        if (items.length === 0) return;

        var event = {
          event: 'view_cart',
          ecommerce: {
            currency: cart.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'TRY',
            value: trackedCartValue(cart),
            cart_id: (cart.token || '').split('?')[0],
            cart_source: 'popup_drawer',
            items: items,
          },
        };
        push(event);
      })
      .catch(function () { });
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    var wasActive = drawer.classList.contains('active');
    new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');
      if (isActive && !wasActive) emitDrawerViewCart();
      wasActive = isActive;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function dispatch(payload) {
    if (!payload) return;
    switch (payload.source) {
      case 'product-form':
        handleProductFormAdd(payload);
        baselinePromise = null;
        ensureBaseline();
        break;
      case 'cart-items':
      case 'cart-drawer-items':
        handleCartQuantityChange(payload);
        break;
    }
    // Keep the checkout bridge current after every cart mutation.
    refreshCheckoutSnapshot();
  }

  function trySubscribe() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, dispatch);
      return true;
    }
    return false;
  }

  function init() {
    ensureBaseline();
    watchDrawer();
    refreshCheckoutSnapshot();
    if (!trySubscribe()) {
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (trySubscribe() || tries > 40) clearInterval(iv);
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// custom code end
